import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'bz-loading',
    template: `
        <div *ngIf="showLoading">
            <bounce>
                {{message | translate}}
            </bounce>  
        </div>
    `,
    styles: [`
        :host {
            position: absolute;
            top: 50%;   
            width: 90%;
        }    
    `]

})
export class LoadingComponent implements OnInit {
    @Input() showLoading: boolean;
    @Input() message = '';

    constructor() { }

    ngOnInit() { }
}
